export const Shield = () => (
  <svg width="43" height="54" viewBox="0 0 43 54" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m21.664.333 20.893 7.034v17.638c0 6.3-2.625 12.283-7.35 16.483l-7.033 6.3-4.83-1.26 9.134-8.085a17.82 17.82 0 0 0 5.984-13.333V10.412L21.664 4.847 4.867 10.413v14.698c0 5.04 2.205 9.974 5.985 13.228l10.813 9.659 3.15 2.835-3.15 2.834L8.017 41.593c-4.62-4.2-7.35-10.184-7.35-16.483V7.367L21.664.333Zm6.405 16.903 2.94 3.045-11.13 11.023-7.558-7.559 2.94-2.94 4.619 4.62 8.189-8.19Z"
      fill="#6FB229"
      fillRule="evenodd"
    />
  </svg>
);
